import { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Card from '../../components/Card';
import "react-responsive-carousel/lib/styles/carousel.min.css";
//image
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from '../../utils/auth';
import { useNavigate } from 'react-router-dom';
import { FaAngleLeft } from "react-icons/fa6";
import LostCardBody from './LostCardBody';
import InfiniteScroll from 'react-infinite-scroll-component';
import loader from "../../assets/images/page-img/page-load-loader.gif";

const LostCard = ({ lostDevices, hasMore, page,setPage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);

    return (
        <>
            {/* <InfiniteScroll
                dataLength={lostDevices?.length}
                next={() => setPage((page) => page + 1)}
                hasMore={hasMore}
                loader={
                    <div className="col-sm-12 text-center">
                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                    </div>
                }
                endMessage={<p className="text-center">No more posts</p>}
            > */}
                {
                    lostDevices?.length > 0 ?
                        lostDevices?.map((data, index) => (
                            <Col sm={12} className=''>
                                <Card className=" card-block card-stretch card-height">
                                    {
                                        index === 0 &&
                                        <div className="card-header d-flex align-items-center gap-3" style={{ borderBottom: "1px solid #80808036" }}>
                                            <FaAngleLeft style={{ fontSize: "15px" }} onClick={() => window.history.back()} />
                                            <h4 className="card-title  mt-2" >{location.pathname.includes('/my-lost-device-list') ? 'My Lost Devices' : 'All Lost Devices'} </h4>
                                        </div>

                                    }
                                    <LostCardBody data={data} index={index} />
                                </Card>
                            </Col>
                        ))
                        :
                        <div>No Lost Devices Found</div>
                }
            {/* </InfiniteScroll> */}
        </>
    )
}

export default LostCard
